import {
    GET_FILTER_INVOICES_FAILD , GET_FILTER_INVOICES_SUCCESS , GET_FILTER_INVOICES_LOADING , GET_FILTER_INVOICES_RESET
} from "../types";

const initialState = {
    loading: false,
    error: null,
    InvoicesList: null,
    status : null 
};

export const invoicesFilterReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any , status :any }
) => {
    switch (action.type) {
        case GET_FILTER_INVOICES_LOADING:
            return {
                ...state,
                loading: action.loading,
                error: null,
            };
        case GET_FILTER_INVOICES_SUCCESS:
            return {
                ...state,
                loading: false,
                InvoicesList: action.payload,
                status : action.status ,
                error: null,
            };
        case GET_FILTER_INVOICES_FAILD:
            return {
                ...state,
                loading: false,
                InvoicesList: null,
                status: action.status , 
                error: action.error,
            };
        case GET_FILTER_INVOICES_RESET:
            return initialState;
        default:
            return state;
    }
};
